var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/babel-runtime/node_modules/core-js/library/modules/_has.js
// module id = 85
// module chunks = 0